export default __webpack_public_path__ + "static/media/ami.6e1897a1.png";